import logging from '@wr/logging';
import config from '../../config';
import eventIds from '../../event-ids';
import {fetchProvider} from '../../utils/fetchProvider';
import {cyberSourceSetSubmitting} from '../cybersource/action-creators';
import {authorizationWith3ds, paymentProcess} from '../cybersource/browser';
import {genericErrorHasOccurred} from '../generic-error/action-creators';
import {removeCreditCardSucceeded} from './action-creators';

const removeCreditCard = (csrfToken, body) => dispatch => {
    const url = `${window.location.href}/credit-card/remove`;

    return fetchProvider(url, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'csrf-token': csrfToken
        },
        body: JSON.stringify(body)
    })
        .then(() => {
            dispatch(removeCreditCardSucceeded(body.registrationId));
        })
        .catch(error => {
            const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
            logger.error(`Error removing saved card: ${error.message}`, {
                error: error.message,
                eventId: eventIds['Error removing saved card']
            });
            return dispatch(genericErrorHasOccurred(true));
        });
};

const startAuthorizationSavedCard = (
    csrfToken,
    languageCode,
    availableLanguageCodes,
    shouldUseSavedCard,
    registrationId,
    cvv
    // eslint-disable-next-line consistent-return
) => async (dispatch, getState) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const {cyberSourceData: {data: {cardinalSessionId}}} = getState();

    dispatch(cyberSourceSetSubmitting(true));

    const enrollData = {
        cardinalSessionId,
        shouldUseSavedCard,
        cardRegistrationDetails: {
            cardRegistrationId: registrationId,
            cvv
        }
    };

    try {
        return await paymentProcess({
            csrfToken,
            enrollData,
            languageCode,
            availableLanguageCodes,
            authorization3dsProvider: authorizationWith3ds,
            scope: 'actions/savedCards'
        });
    } catch (error) {
        dispatch(cyberSourceSetSubmitting(false));
        dispatch(genericErrorHasOccurred(true));

        logger.error(`CyberSource card saved authorization process failed: ${error.message}`, {
            error: error.message,
            eventId: eventIds['CyberSource card saved authorization process failed']
        });
    }
};

export default {
    removeCreditCard,
    startAuthorizationSavedCard
};
